import styled from 'styled-components';

export const ContactContainer = styled.div`
  width: 100%;
`;

export const ContactHero = styled.section`
  background: linear-gradient(rgba(34, 139, 34, 0.8), rgba(34, 139, 34, 0.8)),
              url('/contact-hero.jpg') center/cover;
  padding: 100px 0;
  color: white;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const ContactContent = styled.section`
  padding: 80px 0;
  background: #f8f9fa;
`;

export const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const ContactInfo = styled.div`
  h2 {
    font-size: 2.2rem;
    color: #228B22;
    margin-bottom: 30px;
    font-weight: 600;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #555;
    margin-bottom: 30px;
  }
`;

export const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  svg {
    width: 24px;
    height: 24px;
    color: #228B22;
    flex-shrink: 0;
  }
  
  div {
    h3 {
      font-size: 1.1rem;
      color: #333;
      margin-bottom: 5px;
      font-weight: 600;
    }
    
    p {
      color: #666;
      margin: 0;
      font-size: 1rem;
    }
  }
`;

export const ContactForm = styled.form`
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  
  h2 {
    font-size: 2.2rem;
    color: #228B22;
    margin-bottom: 30px;
    font-weight: 600;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 25px;
  
  label {
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 1rem;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    font-family: inherit;
    
    &:focus {
      outline: none;
      border-color: #228B22;
    }
    
    &::placeholder {
      color: #999;
    }
  }
  
  textarea {
    resize: vertical;
    min-height: 120px;
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 100%;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(34, 139, 34, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const MapSection = styled.section`
  padding: 80px 0;
  background: white;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const MapContainer = styled.div`
  height: 400px;
  background: #f8f9fa;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 1.2rem;
  border: 2px solid #e9ecef;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
    border-radius: inherit;
  }
`;

export const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #c3e6cb;
`;

export const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
`;
